type LoaderProps = {
  label?: string;
  fullScreen?: boolean;
};

export function Loader({ label = 'Loading…', fullScreen = false }: LoaderProps) {
  const body = (
    <div className="flex items-center justify-center gap-3 text-sm font-medium text-slate-600" role="status" aria-live="polite">
      <span className="h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-r-blue-600" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );

  return fullScreen ? <div className="grid min-h-screen place-items-center bg-slate-100">{body}</div> : <div className="py-8">{body}</div>;
}

export default Loader;
